var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass:
        "order-return-review-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Review customer details and address\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("\n    Review the customer details before proceeding.\n  "),
      ]),
      _vm._v(" "),
      !_vm.allCustomerDataFilled && !_vm.loading
        ? _c("el-alert", {
            attrs: {
              closable: false,
              title: _vm.alertComponent.title,
              type: "warning",
              description: _vm.alertComponent.description,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCustomerAuthorized
        ? _c("el-alert", {
            attrs: {
              closable: false,
              title: _vm.findAlertByKey("customerAuthorizationRequired").title,
              type: "warning",
              description: _vm.findAlertByKey("customerAuthorizationRequired")
                .description,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "24px" } }, [
        _c("div", { staticClass: "section-header" }, [
          _c("div", { staticClass: "flex-1" }, [
            _vm._v("\n        Customer Details\n      "),
          ]),
          _vm._v(" "),
          _vm.isCustomerAuthorized
            ? _c(
                "a",
                {
                  staticClass: "edit-details-link",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:editDetails", true)
                    },
                  },
                },
                [_vm._v("\n        Edit Customer Details\n      ")]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "return-customer-details" },
        [
          _c("el-card", { attrs: { shadow: "never" } }, [
            _c("div", { staticClass: "flex flex-col" }, [
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Name\n          "),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.customer.first_name) +
                      " " +
                      _vm._s(_vm.customer.last_name)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Phone Number\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.customer.phone_number))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Email\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.customer.email))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex flex-row",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Street\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.address.address1) +
                        " " +
                        _vm._s(_vm.address.address2)
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            City\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.city))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            State/province/area\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.state))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Zip code\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.zip_code))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Country\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.country))]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }